import React from 'react';
import orange from '@mui/material/colors/orange';
import {useAuthMethod, useAuthUser} from '../../../../utility/AuthHooks';
import {Box} from '@mui/material';
import Avatar from '@mui/material/Avatar';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import {Fonts} from '../../../../../shared/constants/AppEnums';
import PropTypes from 'prop-types';

const ROLE_LABELS = {
  superadmin: 'Super Admin',
  provider: 'Provider',
  user: 'User',
  portal_user: 'Portal User',
};

const UserInfo = ({color}) => {
  const {logout} = useAuthMethod();
  const {user} = useAuthUser();

  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClick = (event) => setAnchorEl(event.currentTarget);
  const handleClose = () => setAnchorEl(null);

  const displayName = user?.name || user?.full_name || user?.email || 'User';
  const roleLabel = ROLE_LABELS[user?.role] || user?.role || 'Authorized';

  const getUserAvatar = () => displayName.charAt(0).toUpperCase();

  return (
    <>
      <Box
        onClick={handleClick}
        sx={{
          py: 0,
          px: 3,
          display: 'flex',
          alignItems: 'center',
          cursor: 'pointer',
          height: {xs: 56, sm: 70},
        }}
        className='user-info-view'
      >
        <Box sx={{py: 0.5}}>
          <Avatar
            sx={{
              height: 40,
              width: 40,
              fontSize: 24,
              backgroundColor: orange[500],
            }}
          >
            {getUserAvatar()}
          </Avatar>
        </Box>
        <Box
          sx={{
            width: {xs: 'calc(100% - 62px)', xl: 'calc(100% - 72px)'},
            ml: 4,
            color: color,
          }}
          className='user-info'
        >
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
            }}
          >
            <Box
              sx={{
                mb: 0,
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
                fontSize: 16,
                fontWeight: Fonts.MEDIUM,
                color: 'inherit',
              }}
              component='span'
            >
              {displayName}
            </Box>
            <Box sx={{ml: 3, color: 'inherit', display: 'flex'}}>
              <ExpandMoreIcon />
            </Box>
          </Box>
          <Box
            sx={{
              mt: -0.5,
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
              color: 'inherit',
            }}
          >
            {roleLabel}
          </Box>
        </Box>
      </Box>

      <Menu
        id='simple-menu'
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
        anchorOrigin={{vertical: 'bottom', horizontal: 'right'}}
        transformOrigin={{vertical: 'top', horizontal: 'right'}}
      >
        <MenuItem
          onClick={() => {
            handleClose();
            logout();
          }}
        >
          Sign Out
        </MenuItem>
      </Menu>
    </>
  );
};

export default UserInfo;

UserInfo.defaultProps = {
  color: 'text.secondary',
};

UserInfo.propTypes = {
  color: PropTypes.string,
};
